<template>
  <div class="po-r w100 bg-w pt20 pb20 pl20 pr20" v-loading="loading">
    <p class="w100 font-16">办公区分组配置</p>
    <div class="w100 pb20 cl-f">
      <div class="fr">
        搜索关键字：
        <el-input class="mr20" style="width: 200px;" v-model="searchText" @keyup.enter.native="fetchList" placeholder="可输入关键字查询"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()">查询</el-button>
        <el-button type="warning" :loading="loading" @click="showAddView">新增</el-button>
      </div>
    </div>

    <el-table class="w100 tx-c my-table" :data="list" stripe border height="550" :default-sort="{ prop: 'sort' }">
      <el-table-column align="center" label="排序" prop="sort" width="80" sortable></el-table-column>
      <el-table-column align="center" label="分组名称" prop="name"></el-table-column>
      <el-table-column align="center" label="分组编码" prop="code"></el-table-column>
      <el-table-column align="center" label="启用状态" width="90">
        <template slot-scope="scope">
          <span class="green" v-if="scope.row.status == 0">启用</span>
          <span class="grey" v-else-if="scope.row.status == 1">停用</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <span class="mr10 blue cu-p font-14" @click="showEditView(scope.row)"><i class="el-icon-edit"></i></span>
          <span class="ml10 red cu-p font-14" @click="delRole(scope.row)"><i class="el-icon-delete"></i></span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[5, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing">
      <span class="font-16" slot="title">{{ title ? title : '新增' }}</span>
      <div class="w100">
        <table class="w100 table-view" v-if="selData">
          <tbody>
            <tr>
              <td>分组名称</td>
              <td>
                <el-input v-model="selData.name" placeholder="请输入分组名称"></el-input>
              </td>
            </tr>
            <tr>
              <td>是否启用</td>
              <td>
                <el-switch v-model="selData.status" active-color="#13ce66"></el-switch>
              </td>
            </tr>
            <tr>
              <td>排序</td>
              <td>
                <el-input-number v-model="selData.sort" :max="999" :min="1"></el-input-number>
              </td>
            </tr>
            <tr>
              <td>分组编码</td>
              <td>
                <el-input v-model="selData.code" placeholder="请输入分组编码"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :loading="updataing" :disabled="selData.name == '' || !selData.sort || selData.code == ''" @click="cilckUpdata">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeServeGroup",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      searchText: "",
      list: [],
      page: 1,
      size: 30,
      total: 0,

      updataing: false,
      isShow: false,
      title: "",
      selData: {
        id: "",
        name: "",
        status: true,
        sort: 1,
        code: ""
      }
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {
    this.fetchList();
  },
  mounted() {},
  methods: {
    delRole(obj) {
      this.$confirm("是否删除 " + obj.name + " 这个分组", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;

          this.$http
            .post(
              "wiseduGroup/delete",
              this.$qs.stringify({
                id: obj.id
              })
            )
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.RetCode && data.RetStatus == 0) {
                this.$message({
                  message: data.RetData,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.RetMsg,
                  type: "error"
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    cilckUpdata() {
      let url = "";
      let obj = {};
      if (this.title == "") {
        url = "wiseduGroup/add";
        obj.name = this.selData.name;
        obj.status = this.selData.status ? 0 : 1;
        obj.sort = this.selData.sort;
        obj.code = this.selData.code;
      } else {
        url = "wiseduGroup/update";
        obj.id = this.selData.id;
        obj.name = this.selData.name;
        obj.status = this.selData.status ? 0 : 1;
        obj.sort = this.selData.sort;
        obj.code = this.selData.code;
      }

      this.updataing = true;
      this.$http
        .post(url, this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode && data.RetStatus == 0) {
            this.$message({
              message: data.RetData,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.updataing = false;
          this.isShow = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.updataing = false;
          this.isShow = false;
        });
    },
    showAddView() {
      this.title = "";
      this.selData = {
        id: "",
        name: "",
        status: true,
        sort: this.list.length + 1,
        code: ""
      };
      this.isShow = true;
    },
    showEditView(obj) {
      this.title = obj.name;
      this.selData = {
        id: obj.id,
        name: obj.name,
        status: obj.status == 1 ? false : true,
        sort: obj.sort,
        code: obj.code
      };
      this.isShow = true;
    },
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          `wiseduGroup/findPage`,
          this.$qs.stringify({
            pageNum: this.page,
            pageSize: this.size,
            name: this.searchText
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetCode && data.RetStatus == 0) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  },
  watch: {}
};
</script>

<style scoped>
.table-view {
  border-collapse: collapse;
}
.table-view td {
  padding: 10px;
  border: 1px solid #dddddd;
}
.table-view tr td:first-child {
  min-width: calc(5em + 20px);
  background: #efefef;
}
</style>
